export type BookingFormLayout = 'full' | 'embed'
export type BookingPhase = 'choose' | 'contact' | 'pay' | 'confirmed'

export type FormChrome = {
  pageChrome: boolean
  showOverview: boolean
  showMap: boolean
  showDesktopInlinePanel: boolean
  overlayAllBreakpoints: boolean
  showStickyBar: boolean
}

/**
 * The ONE decision table for what the booking form renders around the panel
 * in each layout. 'full' reproduces the historical /bookings page exactly.
 * 'embed' (booking_widget content section) keeps selection inline and pushes
 * the contact/pay/confirmed phases into the step-sheet overlay at every
 * breakpoint — checkout never plays out mid-page on a marketing page.
 */
export function formChrome(args: {
  layout: BookingFormLayout
  phase: BookingPhase
  hasSelection: boolean
}): FormChrome {
  const { layout, phase, hasSelection } = args
  const embed = layout === 'embed'
  return {
    pageChrome: !embed,
    showOverview: !embed,
    showMap: !embed,
    showDesktopInlinePanel: embed ? phase === 'choose' : true,
    overlayAllBreakpoints: embed,
    showStickyBar: phase === 'choose' && (!embed || hasSelection),
  }
}
